import type { ApiClient } from "@carepass/api-client";
import type { Schemas } from "../workspace/api.generated";
import type { ExportListCriteria, ExportRequestValues } from "./schema";

export async function getExports(api: ApiClient, criteria: ExportListCriteria, signal?: AbortSignal) {
  return (await api.get<Schemas["AdminPageDataExportJobView"]>("/api/v1/admin/operations/exports", {
    query: {
      status: criteria.status || undefined,
      exportType: criteria.exportType || undefined,
      requestedFrom: criteria.requestedFrom || undefined,
      requestedTo: criteria.requestedTo || undefined,
      page: criteria.page,
      size: criteria.size,
    },
    signal,
    cache: "no-store",
  })).data;
}

export async function getExport(api: ApiClient, jobId: string, signal?: AbortSignal) {
  return (await api.get<Schemas["DataExportJobView"]>(`/api/v1/admin/operations/exports/${encodeURIComponent(jobId)}`, {
    signal,
    cache: "no-store",
  })).data;
}

export async function requestSettlementExport(api: ApiClient, values: ExportRequestValues, signal?: AbortSignal) {
  return (await api.post<Schemas["DataExportJobView"]>("/api/v1/admin/operations/exports/settlements", undefined, {
    query: { from: values.from, to: values.to, reason: values.reason.trim() },
    signal,
    cache: "no-store",
  })).data;
}
